import React, { FC } from 'react'

type SecondaryAction = 'change' | 'logout' | null

type Props = {
  onChangeStep: () => void
  onLogout: () => void
  secondaryAction: SecondaryAction
}

const ContactStepHeader: FC<Props> = ({ secondaryAction, onChangeStep, onLogout }) => {
  return (
    <h2 className="checkout-step__header / h4">
      <span>Contact</span>
      {secondaryAction === 'logout' ? (
        <button className="checkout-button / ml-auto" type="button" onClick={onLogout}>
          Log out
        </button>
      ) : null}
      {secondaryAction === 'change' ? (
        <button className="checkout-button / ml-auto" type="button" onClick={onChangeStep}>
          Change
        </button>
      ) : null}
    </h2>
  )
}

export default ContactStepHeader
